import { render, staticRenderFns } from "./alertas.vue?vue&type=template&id=3a9e50cb&"
import script from "./alertas.vue?vue&type=script&lang=js&"
export * from "./alertas.vue?vue&type=script&lang=js&"
import style0 from "./alertas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports